"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = exports.ColorConfig = exports.ColorFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../../validators");
exports.ColorFieldType = "Color";
exports.ColorConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
    placeholder: t.string,
}));
exports.Color = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.ColorFieldType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        config: exports.ColorConfig,
    }),
]));
